<template>
  <div class='desConsuit'>
    <!-- <div class="tit">
    </div> -->
    <img class="tit" src="@/assets/mine/tip.png" alt="">

    <textarea v-model="text" class="text" name="" id="" cols="30" rows="10" placeholder="请输入您的问题"></textarea>

    <div @click="submit" class="submit">提交</div>
  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import Des from '@/util/des.js'

export default {
  name: 'desConsuit',
  components: {
  },
  data() {
    return {
      text: ''
    }
  },
  computed: { },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    submit() {
      const stamp = Date.now()
      const user_id = JSON.parse(localStorage.getItem('giftsUser')).id
      const userToken = localStorage.getItem('token')
      const data = {
        stamp,
        user_id,
        userToken,
        consult_content: this.text,
        sign: md5(user_id + '' + stamp + atob(localStorage.getItem('key')))
      }
      axios.post('/api/xiaosen/user/design/doDesignConsult', qs.stringify(data)).then(res => {
        if (res.data.result === 1) {
          this.text = ''
          this.$message({message: res.data.msg, type: 'success'})
        } else {
          this.$message(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.desConsuit {
  margin-top: 59px;
  position: relative;
  width: 100%;
  background: #FFFFFF;
  border-radius: 32px;
  .tit{
    position: absolute;
    top: -30px;
    left: 22px;
    width: 144px;
    height: 50px;
    -webkit-user-select: none;
    .top{
      font-size: 24px;
    }
  }
  .text{
    box-sizing: border-box;
    width: 100%;
    height: 314px;
    border-radius: 21px 0px 21px 0px;
    border: 2px solid #B8D4B4;
    outline: none;
    resize: none;
    padding: 40px 30px;
    font-size: 20px;
    vertical-align: top;
  }
  .submit{
    cursor: pointer;
    width: 160px;
    height: 50px;
    line-height: 50px;
    background: #4E8B46;
    border-radius: 32px 32px 32px 32px;
    font-size: 20px;
    color: #FFFFFF;
    margin-top: 28px;
  }
}
</style>
